import { render, staticRenderFns } from "./Wfd.vue?vue&type=template&id=1ead08a1&scoped=true&"
import script from "./Wfd.vue?vue&type=script&lang=js&"
export * from "./Wfd.vue?vue&type=script&lang=js&"
import style0 from "./Wfd.vue?vue&type=style&index=0&id=1ead08a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ead08a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ead08a1')) {
      api.createRecord('1ead08a1', component.options)
    } else {
      api.reload('1ead08a1', component.options)
    }
    module.hot.accept("./Wfd.vue?vue&type=template&id=1ead08a1&scoped=true&", function () {
      api.rerender('1ead08a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/gva-wfd/components/Wfd.vue"
export default component.exports